const RTX_SALESFORCE_ID = "0011U00001kiHTaQAM" as const

export const isRtxSalesforceId = (salesforceAccountId: string | null | undefined): boolean => {
  return salesforceAccountId === RTX_SALESFORCE_ID
}
